import { render, staticRenderFns } from "./RevisionCard.vue?vue&type=template&id=bfe5f2a0&scoped=true&"
import script from "./RevisionCard.vue?vue&type=script&lang=js&"
export * from "./RevisionCard.vue?vue&type=script&lang=js&"
import style0 from "./RevisionCard.vue?vue&type=style&index=0&id=bfe5f2a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe5f2a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VDivider})
